// src/components/charts/CriticScoreHistogram.jsx
//
// Histogram of critic_score across a sample of completed runs.
// 10-point bins (0-9, 10-19, ..., 90-100). Null scores dropped.
// Sample-based — never population-true.
//
import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Bin critic_score values into 10-point buckets.
 * Returns [{ bin: '0-9', count: N }, ...]. Skips rows with null score.
 * Exported for unit testing.
 */
export function binCriticScores(runs) {
  const bins = [
    { bin: '0-9',   from: 0,   to: 10  },
    { bin: '10-19', from: 10,  to: 20  },
    { bin: '20-29', from: 20,  to: 30  },
    { bin: '30-39', from: 30,  to: 40  },
    { bin: '40-49', from: 40,  to: 50  },
    { bin: '50-59', from: 50,  to: 60  },
    { bin: '60-69', from: 60,  to: 70  },
    { bin: '70-79', from: 70,  to: 80  },
    { bin: '80-89', from: 80,  to: 90  },
    { bin: '90-100',from: 90,  to: 101 },
  ].map(b => ({ ...b, count: 0 }));
  if (!Array.isArray(runs)) return bins.map(({ bin, count }) => ({ bin, count }));
  for (const r of runs) {
    const s = r?.critic_score;
    if (s == null || Number.isNaN(s)) continue;
    const target = bins.find(b => s >= b.from && s < b.to);
    if (target) target.count += 1;
  }
  return bins.map(({ bin, count }) => ({ bin, count }));
}

export default function CriticScoreHistogram({ runs }) {
  const rows = binCriticScores(runs);
  if (rows.every(r => r.count === 0)) return null;
  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={rows} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
        <XAxis dataKey="bin" tick={{ fontSize: 11, fill: '#6c6c6d' }} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#6c6c6d' }} />
        <Tooltip contentStyle={{ fontSize: 12, fontFamily: "'DM Sans', sans-serif" }} />
        <Bar dataKey="count" fill="#10B981" />
      </BarChart>
    </ResponsiveContainer>
  );
}
